var map = {
	"./common.js": "./src/common/common.js",
	"./homepage-blocks/homepage-competence-center.js": "./src/common/homepage-blocks/homepage-competence-center.js",
	"./homepage-blocks/homepage-our-projects.js": "./src/common/homepage-blocks/homepage-our-projects.js",
	"./homepage-blocks/homepage-spec-projects.js": "./src/common/homepage-blocks/homepage-spec-projects.js",
	"./registerBlocks.js": "./src/common/registerBlocks.js",
	"./solution-blocks/solution-additional-materials/solution-additional-materials.js": "./src/common/solution-blocks/solution-additional-materials/solution-additional-materials.js",
	"./solution-blocks/solution-gallery-solutions/solution-gallery-solutions.js": "./src/common/solution-blocks/solution-gallery-solutions/solution-gallery-solutions.js",
	"./solution-blocks/solution-more-cases/solution-more-cases.js": "./src/common/solution-blocks/solution-more-cases/solution-more-cases.js",
	"./solution-blocks/solution-solutions-with-description/solution-solutions-with-description.js": "./src/common/solution-blocks/solution-solutions-with-description/solution-solutions-with-description.js",
	"./solution-blocks/solution-team/solution-team.js": "./src/common/solution-blocks/solution-team/solution-team.js",
	"./solution-blocks/solution-vendors/solution-vendors.js": "./src/common/solution-blocks/solution-vendors/solution-vendors.js",
	"./techart-theme/header.js": "./src/common/techart-theme/header.js",
	"common/common.js": "./src/common/common.js",
	"common/homepage-blocks/homepage-competence-center.js": "./src/common/homepage-blocks/homepage-competence-center.js",
	"common/homepage-blocks/homepage-our-projects.js": "./src/common/homepage-blocks/homepage-our-projects.js",
	"common/homepage-blocks/homepage-spec-projects.js": "./src/common/homepage-blocks/homepage-spec-projects.js",
	"common/registerBlocks.js": "./src/common/registerBlocks.js",
	"common/solution-blocks/solution-additional-materials/solution-additional-materials.js": "./src/common/solution-blocks/solution-additional-materials/solution-additional-materials.js",
	"common/solution-blocks/solution-gallery-solutions/solution-gallery-solutions.js": "./src/common/solution-blocks/solution-gallery-solutions/solution-gallery-solutions.js",
	"common/solution-blocks/solution-more-cases/solution-more-cases.js": "./src/common/solution-blocks/solution-more-cases/solution-more-cases.js",
	"common/solution-blocks/solution-solutions-with-description/solution-solutions-with-description.js": "./src/common/solution-blocks/solution-solutions-with-description/solution-solutions-with-description.js",
	"common/solution-blocks/solution-team/solution-team.js": "./src/common/solution-blocks/solution-team/solution-team.js",
	"common/solution-blocks/solution-vendors/solution-vendors.js": "./src/common/solution-blocks/solution-vendors/solution-vendors.js",
	"common/techart-theme/header.js": "./src/common/techart-theme/header.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common sync recursive .(js%7Ccss%7Cscss%7Csass%7Cless)$";